import lrRadio from './_src/lrRadio.vue'

lrRadio.install = function(Vue) {
  Vue.component(lrRadio.name, lrRadio)
}

export default lrRadio